import React from 'react'
import { Map, List } from 'immutable'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from '../../../actions/index'
import { ICON_COLORS } from '../../Icon/index'
import FilePdfIcon from '../../Icon/icons/FilePdf/index'
import DownloadIcon from '../../Icon/icons/Download/index'
import Link, { TARGET_BLANK } from '../../Link/index'

/**
   * Course detail page resources tab component
 * @param {Object} props - The props
 * @param {Map} props.detailData - The content details data
 * @param {List} props.resourcesData - The resources data
 * @param {Map} props.staticText - The static text data
 * @returns {JSX.Element} DetailPageV3CourseResources
 */

const DetailPageV3CourseResources = (props) => {
  const {
    resourcesData = List(),
    staticText,
  } = props

  return (
    <div className="detail-page-v3__course-resources">
      {resourcesData.map((asset, index) => (
        <div key={asset.get('uuid') || index} className="detail-page-v3__course-resource">
          <FilePdfIcon size={42} color="#B03874" />
          <div className="detail-page-v3__course-resource-content">
            <p className="detail-page-v3__course-resource-filename">
              {asset.get('fileName')}
            </p>
            <div className="detail-page-v3__course-resource-meta">
              <Link
                directLink
                target={TARGET_BLANK}
                to={asset.get('url')}
                className="detail-page-v3__course-resource-download"
              >
                <DownloadIcon size={20} color={ICON_COLORS.TEAL} />
                <span className="detail-page-v3__course-resource-meta-text">
                  {staticText.get('download')}
                </span>
              </Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default connectRedux((state) => ({
  staticText: state.staticText.getIn(['data', 'detailPageV3', 'data'], Map()),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    setEventDefault: actions.eventTracking.setEventDefault,
  }
})(DetailPageV3CourseResources)
